export const getDocumentLocale = (): string | undefined => {
  if (typeof document === "undefined") return undefined;
  return document.documentElement.lang || undefined;
};
